type HeadingComponentProps = {
  fontFamily?: string;
  headingText?: string;
  margin?: string;
  fontSize?: string;
  fontSizeMobile?: string;
  fontWeight?: string;
  marginMobile?: boolean;
  marginHeadingMobile?: string;
  justifyMobile?: boolean;
  widthAuto?: boolean;
  lineHeight?: string;
  textAlignMobile?: string;
};

const HeadingComponent = ({
  fontFamily,
  headingText,
  margin,
  fontSize,
  fontSizeMobile,
  fontWeight,
  marginMobile,
  marginHeadingMobile,
  justifyMobile = false,
  widthAuto,
  lineHeight,
  textAlignMobile
}: HeadingComponentProps) => {
  const font = fontFamily ? fontFamily : "Roboto; font-weight: bold";
  return (
    <div className="heading-text-container">
      <h1 className="heading-text">{headingText}</h1>
      <style jsx>{`
        .heading-text-container {
          display: flex;
          justify-content: center;
        }
        .heading-text {
          text-align: center;
          font-family: ${font};
          width: ${widthAuto ? "auto" : "688px"};
          font-size: ${fontSize ? fontSize : "24px"};
          margin: ${margin};
          font-weight: ${fontWeight ? fontWeight : "normal"};
          line-height: : ${lineHeight ? lineHeight : ""}
        }
        @media only screen and (max-width: 700px) {
          .heading-text {
            margin: ${marginHeadingMobile ? marginHeadingMobile : "16px"};
            font-size: ${fontSizeMobile ? fontSizeMobile : "18px"};
            width: auto;
            font-weight: ${fontWeight ? fontWeight : "normal"};
            text-align: ${textAlignMobile ? textAlignMobile : "center"}
          }
          .heading-text-container {
            justify-content: ${justifyMobile ? "end" : ""};
            margin: ${marginMobile ? "0 0 0 10px" : ""};
          }
        }
      `}</style>
    </div>
  );
};

export default HeadingComponent;
